import { request } from '@/api/request'

export interface LoginData {
  email: string
  password: string
}

export const login = async (loginData: LoginData) => {
  return request.post('/auth/login', loginData)
}

export const logout = async () => {
  return request.post('/auth/logout', {})
}

export const me = async () => {
  return request.get('/auth/me', {})
}

export const requestForgotPassword = async (email: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('client_id', email);

  const { data } = await request.post('/webapi/auth/forgot/request', bodyFormData)

  return data.value
}

export const verifyForgotPassword = async (token: string, password: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('token', token);
  bodyFormData.set('password', password);

  const { data } = await request.post('/webapi/auth/forgot/apply', bodyFormData)

  return data.value
}